/**
 * Minimal client-side HTML cleanup for admin-composed email bodies.
 * @param {string} html
 * @returns {string}
 */
export function sanitizeEmailHtml(html) {
  const raw = (html || "").trim();
  if (!raw) return "";
  if (typeof document === "undefined") return raw;
  const d = document.createElement("div");
  d.innerHTML = raw;
  d.querySelectorAll("script,style,iframe,object,embed,link,meta").forEach((n) => n.remove());
  d.querySelectorAll("*").forEach((el) => {
    [...el.attributes].forEach((a) => {
      const n = a.name.toLowerCase();
      if (n.startsWith("on") || n === "srcdoc") el.removeAttribute(a.name);
      if ((n === "href" || n === "src") && /^\s*javascript:/i.test(a.value)) {
        el.removeAttribute(a.name);
      }
    });
  });
  return d.innerHTML;
}

export function isProbablyHtml(s) {
  return /<\/?[a-z][a-z0-9]*[\s>/]/i.test(String(s || ""));
}

export function plainTextFromHtml(html) {
  if (typeof document === "undefined") return String(html || "").replace(/<[^>]+>/g, " ");
  const d = document.createElement("div");
  d.innerHTML = html || "";
  return (d.textContent || "").replace(/\s+/g, " ").trim();
}

function escapeHtmlText(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Turn plain text (paragraphs separated by blank lines) into safe HTML for the rich composer.
 * @param {string} text
 * @returns {string}
 */
export function plainTextToEmailBodyHtml(text) {
  const t = String(text || "").trim();
  if (!t) return "";
  return t
    .split(/\n\n+/)
    .map((block) => {
      const inner = escapeHtmlText(block).replace(/\n/g, "<br />");
      return `<p>${inner}</p>`;
    })
    .join("");
}
